const setMenu = menu => {
    return {
        type: "SET_MENU",
        menu
    }
}

const setModalContent = modalContent => {
    return {
        type: "SET_MODAL_CONTENT",
        modalContent
    }
}

const setFiltersContent = filtersContent => {
    return {
        type: "SET_FILTERS_CONTENT",
        filtersContent
    }
}

const setSelectedFilters = selectedFilters => {
    return {
        type: "SET_SELECTED_FILTERS",
        selectedFilters
    }
}

const setUsers = users => {
    return {
        type: "SET_USERS",
        users
    }
}

const setClients = clients => {
    return {
        type: "SET_CLIENTS",
        clients
    }
}

const setSelectedClients = selectedClients => {
    return {
        type: "SET_SELECTED_CLIENTS",
        selectedClients
    }
}

const setSelectedUsers = selectedUsers => {
    return {
        type: "SET_SELECTED_USERS",
        selectedUsers
    }
}

const setClientsPagination = pagination => {
    return {
        type: "SET_CLIENTS_PAGINATION",
        clientsPagination: pagination
    }
}

const setBillsPagination = pagination => {
    return {
        type: "SET_BILLS_PAGINATION",
        billsPagination: pagination
    }
}

export { setMenu, setModalContent, setFiltersContent, setSelectedFilters, setUsers, 
    setSelectedClients, setClients, setSelectedUsers, setClientsPagination, setBillsPagination};
